import React, { Fragment, useContext, useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { UserContext } from "../UserContext";
import { hasAnyPerm } from '../utils/uiUtils';
import { useTranslation } from 'react-i18next';
import { axiosAuth_PLATFORM_API } from '../utils/AxoisUtilComponent';
import TemplateListView    from "./TemplateListView";
import UiCompAdminDetailsView from "./UiCompAdminDetailsView";
import UiCompAdminNewView     from "./UiCompAdminNewView";


const UiCompAdmin = () => {

  const { t }    = useTranslation(["common"]);
  const { user } = useContext(UserContext);
  const navigate = useNavigate();

  const [uiMode,     setUIMode]     = useState('LIST');
  const [objDetails, setObjDetails] = useState({});
  const [pageState,  setPageState]  = useState({
                                        searchTerms: null,
                                        sortCol:     null,
                                        sortDir:     null,
                                        perPage:     25,
                                        currPage:    1});

  // Initialize state
  useEffect(() => {

    // Route to home page if not authorized
    if (!hasAnyPerm(user, ["BuildingAdminGeneralWriteAccess"], true)) {
      navigate("/AdminHome/Dashboard", {
        state: {
          //...values
          target: 'Dashboard'
        }
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  // ----- Data Table stuff -----

  const tableColumns = [
    {
      igcColumnType: 'PRIMARY_ID',
      name: t("I18N_UiComp_name"),
      sortable: true,
      sortField: 'name',
      grow: 2,
      cell: null
    },
    {
      name: t("I18N_Description"),
      selector: row => row.description,
      grow: 2.5,
      wrap: true
    },
    {
      name: t("I18N_Type"),
      grow: 2,
      selector: row => row.type,
      sortable: true,
      sortField: 'type'
    },
    {
      igcColumnType: 'DELETE',
      name: '',
      selector: row => row.id,
      grow: 0.5,
      cell: null
    }
  ];

  // ----- END - Data Table stuff -----


  return (
    <Fragment>

      {(uiMode === 'LIST')    ? <TemplateListView pageState={pageState}
                                                  axiosAPI={axiosAuth_PLATFORM_API}
                                                  apiObjName={'ui-comps'}
                                                  listPageTitle={t("I18N_UiComp_Management")}
                                                  newObjTooltip={t("I18N_TIP_New_UI_comp")}
                                                  searchTooltip={t("I18N_Search")}
                                                  deleteConfirmDialogTitle={t("I18N_UiComp_delete_confirm")}
                                                  deleteObjTooltip={t("I18N_TIP_Delete_UI_comp")}
                                                  tableColumns={tableColumns}
                                                  primaryIdColType={'NAME'}
                                                  deletePermission={'BuildingAdminGeneralDeleteAccess'}
                                                  onUIMode={setUIMode}
                                                  onSetPageState={setPageState}
                                                  onSetObjDetails={setObjDetails} /> : null}
      {(uiMode === 'DETAILS') ? <UiCompAdminDetailsView onUIMode={setUIMode} objDetails={objDetails} />                  : null}
      {(uiMode === 'NEW')     ? <UiCompAdminNewView     onUIMode={setUIMode} />                                          : null}

    </Fragment>
  )
}

export default UiCompAdmin;
